import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Multiselect from '@rio-cloud/rio-uikit/lib/es/Multiselect';
import Spinner from '@rio-cloud/rio-uikit/lib/es/Spinner';
import PropTypes from 'prop-types';

import { pdcFetchInspections, setFilter } from '@/actions/pdcActions';
import { PDC_SEVERITY_HIGH, PDC_SEVERITY_LOW, PDC_SEVERITY_MEDIUM, VEHICLE_CONDITION_FILTER } from '@/constants';
import { getPDCIsLoading } from '@/selectors';

const isOptionSelected = (filters, item) => filters.indexOf(item) > -1;

const VehicleConditionFilter = ({ filters, isLoading, onVehicleConditionFilterChange }) => {
    const enabledVehicleConditionFilters = filters
        .filter((entry) => entry.filterType === VEHICLE_CONDITION_FILTER)
        .map((entry) => entry.item);

    const vehicleConditionOptions = [
        {
            id: PDC_SEVERITY_LOW,
            label: <FormattedMessage id="intl-msg:filter.vehicle_condition.severity.LOW" />,
            selected: isOptionSelected(enabledVehicleConditionFilters, PDC_SEVERITY_LOW),
        },
        {
            id: PDC_SEVERITY_MEDIUM,
            label: <FormattedMessage id="intl-msg:filter.vehicle_condition.severity.MEDIUM" />,
            selected: isOptionSelected(enabledVehicleConditionFilters, PDC_SEVERITY_MEDIUM),
        },
        {
            id: PDC_SEVERITY_HIGH,
            label: <FormattedMessage id="intl-msg:filter.vehicle_condition.severity.HIGH" />,
            selected: isOptionSelected(enabledVehicleConditionFilters, PDC_SEVERITY_HIGH),
        },
    ];

    return (
        <div className="row">
            <div className="col-md-4 vehicleConditionFilter">
                <label className="control-label">
                    <FormattedMessage id="intl-msg:filter.vehicle_condition.title" />
                </label>
                <div className="display-flex align-items-center">
                    <Multiselect
                        placeholder={<FormattedMessage id="intl-msg:filter.placeholder" />}
                        options={vehicleConditionOptions}
                        onChange={onVehicleConditionFilterChange}
                        counterMessage={{
                            one: <FormattedMessage id="intl-msg:filter.vehicle_condition.one_selected" />,
                            many: <FormattedMessage id="intl-msg:filter.vehicle_condition.many_selected" />,
                        }}
                    />
                    <div className="margin-left-10">{isLoading && <Spinner />}</div>
                </div>
            </div>
        </div>
    );
};

VehicleConditionFilter.propTypes = {
    isLoading: PropTypes.bool,
    filters: PropTypes.array.isRequired,
    onVehicleConditionFilterChange: PropTypes.func,
};

export const mapStateToProps = (state) => ({
    isLoading: getPDCIsLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
    onVehicleConditionFilterChange: (items) => {
        dispatch(setFilter(VEHICLE_CONDITION_FILTER, items));
        dispatch(pdcFetchInspections());
    },
});

export { VehicleConditionFilter };
export default connect(mapStateToProps, mapDispatchToProps)(VehicleConditionFilter);
